import { InputHandle, Stack, Field, ErrorMessage } from "@introist/react-foundation/v2";
import { Block, TextInput } from "components/atoms";
import { MessageEditor as MessageEditorV4 } from "components/editors/v4/MessageEditor/MessageEditor";
import { AttachmentsBlock } from "modules/workflows/blocks/Attachments";
import { StepEditorAccordion } from "modules/workflows/routes/WorkflowEditor/StepEditorAccordion";
import { StepRemindersBlock } from "../StepRemindersBlock";
import { EmailSettings } from "../EmailSettings";
import { useRef, useCallback } from "react";
import { prefixForm } from "utils/FormUtils";
import { StepEditorProps } from "../../useStepEditor";
import { EmailStepAddressBlock } from "../EmailStepAddressBlock";
import { TagSelector } from "../../../../system/tags/TagSelector";
import { Tag } from "modules/system/tags/useTags";
import { useFeatureFlag } from "hooks/use-feature-flag";

export const EmailFormV3StepEditor = ({ form, stepDataPath, workflowId }: StepEditorProps) => {
  const stepRemindersFlag = useFeatureFlag("step-reminders");
  const prefixedForm = prefixForm(form, stepDataPath);

  const inputRef = useRef<InputHandle>(null);

  const addTag = useCallback(
    (tag: Tag) => {
      if (!inputRef.current) return;
      inputRef.current.insertTextToCursorPosition(`{{${tag.tag}}}`);
    },
    [inputRef]
  );

  return (
    <>
      <EmailStepAddressBlock form={form} formKeyPrefix={stepDataPath} />
      <Block compact blended>
        <StepEditorAccordion
          error={
            prefixedForm.isError("subject") || prefixedForm.isError("message")
              ? "Invalid fields"
              : undefined
          }
          title="Message"
          defaultOpen={true}
        >
          <Stack vertical gap="xLarge">
            <Field title="Subject">
              <TextInput
                inputHandleRef={inputRef}
                size="small"
                placeholder="Email subject"
                value={prefixedForm.get("subject")}
                endAdornment={
                  <TagSelector title="" size="small" onSelect={addTag} ctx={{ workflowId }} />
                }
                onChange={prefixedForm.set("subject")}
              />
            </Field>
            <Field title="Message">
              <MessageEditorV4
                message={prefixedForm.get("message")}
                onChange={prefixedForm.set("message")}
                error={prefixedForm.isError("message")}
                formLinks={true}
                workflowId={workflowId}
              />

              {prefixedForm.error("message") && (
                <ErrorMessage>{prefixedForm.error("message")}</ErrorMessage>
              )}
            </Field>
          </Stack>
        </StepEditorAccordion>
      </Block>
      <AttachmentsBlock form={form} />
      {stepRemindersFlag.isEnabled && (
        <StepRemindersBlock form={form} stepDataPath={stepDataPath} workflowId={workflowId} />
      )}
      <EmailSettings form={form} stepDataPath={stepDataPath} />
    </>
  );
};
